import React from 'react'
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useField } from 'formik'

const CustomCheckboxGroup = ({
  name,
  options,
  labelField = 'label',
  valueField = 'value',
  ...props
}) => {
  const classes = useStyles()
  const [field, meta, helpers] = useField(name)
  const { setValue } = helpers
  const errorText = meta.error && meta.touched ? meta.error : ''

  const handleChange = (value) => {
    const currentValues = field.value || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter((v) => v !== value)
      : [...currentValues, value]

    setValue(newValues)
  }

  return (
    <FormControl component="fieldset" className={classes.formControl} error={!!errorText}>
      <FormGroup className={classes.formGroup}>
        {options.map((option) => (
          <FormControlLabel
            key={option[valueField]}
            className={classes.checkboxLabel}
            control={
              <Checkbox
                checked={field.value?.includes(option[valueField])}
                onChange={() => handleChange(option[valueField])}
                color="primary"
                {...props}
              />
            }
            label={option[labelField]}
          />
        ))}
      </FormGroup>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  )
}

export default CustomCheckboxGroup

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%'
  },
  formGroup: {
    flexDirection: 'row'
  },
  checkboxLabel: {
    marginRight: '1rem'
  }
}))
